import { Box } from "@constellation/core";
import styled, { StyledComponent } from "styled-components";

export const StyledGradientBox: StyledComponent<typeof Box, any> = styled<typeof Box>(Box)`
  background-image: linear-gradient(to bottom right, ${({ theme }) => theme.color_source_primary_1}, ${({ theme }) => theme.color_background_panel_brand_2});
  box-sizing: border-box;
`;